module.exports = __webpack_public_path__ + "static/media/47_tn.1f2bfe98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/47_tn.jpg
// module id = 356
// module chunks = 0